import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/views/Home.vue';
import Login from '@/views/login.vue';
import Dictionary from '@/views/dictionary.vue';
import UserInfo from '@/views/userInfo.vue';
import TopicNews from '@/views/topicNews.vue';
import PointsRecord from '@/views/pointsRecord.vue';
import OrderRecord from '@/views/orderRecord.vue';
import ActivityInformation from '@/views/activityInformation.vue';
import ActivityProcedure from '@/views/activityProcedure.vue';
import ActivityRegistrationSigninRecord from '@/views/activityRegistrationSigninRecord.vue';
import PointsChange from '@/views/pointsChange.vue';
import Log from '@/views/log.vue';
import VolunteerApply from '@/views/volunteerApply.vue';
import OrganizerApply from '@/views/organizerApply.vue';
import ActivityReport from '@/views/activityReport.vue';
Vue.use(Router)

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/login'
        },

        {
            path: '/home',
            name: 'home',
            component: Home,
            redirect: '/userInfo',
            children:[
                {
                    path: '/dictionary',
                    name: 'dictionary',
                    component:Dictionary,
                },
                {
                    path: '/userInfo',
                    name: 'userInfo',
                    component:UserInfo,
                },
                {
                    path: '/topicNews',
                    name: 'topicNews',
                    component:TopicNews,
                },
                {
                    path: '/pointsRecord',
                    name: 'pointsRecord',
                    component:PointsRecord,
                },
                {
                    path: '/orderRecord',
                    name: 'orderRecord',
                    component:OrderRecord,
                },
                {
                    path: '/activityInformation',
                    name: 'activityInformation',
                    component:ActivityInformation,
                },
                {
                    path: '/activityProcedure',
                    name: 'activityProcedure',
                    component:ActivityProcedure,
                },
                {
                    path: '/activityRegistrationSigninRecord',
                    name: 'activityRegistrationSigninRecord',
                    component:ActivityRegistrationSigninRecord,
                },
                {
                    path: '/pointsChange',
                    name: 'pointsChange',
                    component:PointsChange,
                },
                {
                    path: '/log',
                    name: 'log',
                    component:Log,
                },
                {
                    path: '/volunteerApply',
                    name: 'volunteerApply',
                    component:VolunteerApply,
                },
                {
                    path: '/organizerApply',
                    name: 'organizerApply',
                    component:OrganizerApply,
                },
                {
                    path: '/activityReport',
                    name: 'activityReport',
                    component:ActivityReport,
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: Login
        },
    ]
})
